import * as Yup from "yup";

import { Strings } from "@app/constants";

export const editProfileSchema = Yup.object()
  .shape({
    firstName: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.firstName),
    ),

    lastName: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.lastName),
    ),

    email: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.email),
    ),

    phone: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.phone),
    ),

    state: Yup.string().required(Strings.validation.fieldRequired(Strings.auth.state)),

    city: Yup.string().required(Strings.validation.fieldRequired(Strings.auth.city)),

    zipCode: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.zipCode),
    ),
  })
  .required();
